import { effect, Injectable, NgZone } from '@angular/core';
import { Router, UrlSegmentGroup, UrlTree } from '@angular/router';
import { take } from 'rxjs';
import { RouteNames } from '../enums/routes.enum';
import { ConfigService } from './config.service';

@Injectable({ providedIn: 'root' })
export class RouteSyncService {
	constructor(
		private router: Router,
		private configService: ConfigService,
		private ngZone: NgZone
	) {
		effect(() => {
			const isMobile = this.configService.isMobileSignal();
			const url = this.router.url;
			const tree = this.router.parseUrl(url);

			this.ngZone.onStable.pipe(take(1)).subscribe(() => {
				const panelGroup: UrlSegmentGroup | undefined = tree.root.children['panel'];
				const primaryGroup: UrlSegmentGroup | undefined = tree.root.children['primary'];

				if (isMobile && panelGroup) {
					// Desktop → Mobile: move panel outlet to primary
					const newUrl = '/' + panelGroup.segments.map(s => s.path).join('/');
					this.router.navigateByUrl(newUrl + this.stringifyQueryParams(tree.queryParams), {
						replaceUrl: true
					});
				} else if (!isMobile && primaryGroup && this.shouldBePanel(primaryGroup)) {
					// Mobile → Desktop: move primary to panel outlet
					const segments = primaryGroup.segments.map(s => s.path);
					const panelTree = this.router.createUrlTree([{ outlets: { panel: segments } }], {
						queryParams: tree.queryParams
					});
					this.router.navigateByUrl(panelTree, { replaceUrl: true });
				}
			});
		});
	}

	private shouldBePanel(group: UrlSegmentGroup): boolean {
		const panelRoutes: string[] = [
			RouteNames.Itinerary,
			RouteNames.CountryGuide,
			RouteNames.DayTrips,
			RouteNames.Favorites,
			RouteNames.Neighborhoods,
			RouteNames.NeighborhoodGuide,
			RouteNames.Journal,
			RouteNames.Visas
		];
		const firstSegment = group.segments[0]?.path || '';
		return panelRoutes.includes(firstSegment);
	}

	private stringifyQueryParams(queryParams: Record<string, any>): string {
		if (!queryParams) return '';
		const keys = Object.keys(queryParams);
		if (!keys.length) return '';
		const query = keys.map(k => `${encodeURIComponent(k)}=${encodeURIComponent(queryParams[k])}`).join('&');
		return `?${query}`;
	}
}
